import axios from "../axios";

export const checkEmailAvailability = (value: string | undefined): Promise<boolean> => {
  if (!value) {
    return Promise.resolve(false);
  }

  return axios
      .post("/user/emailAvailability", {
        email: value,
      })
      .then(({ data }) => {
        return data.emailAvailable;
      })
      .catch((error) => {
        console.error(error);
        return false;
      });
};